import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminDocument(props) {
    const formfolderRef = useRef(null)
    const fileimportRef = useRef(null)

    const [apply_all_sites, setApply_all_sites] = useState(false);
    const [items_count_selected, setItems_Count_Selected] = useState(0);
    const [files, setFiles] = useState([]);

    const [document_info, setDocument_info] = useState({
        selected_all: false,
        control_folder: false,
        control_file: false,
        step_back: 'documents',
        current_path: 'documents',
        doc_list: []
    });

    const [folder_text, setFolder_text] = useState("")
    const [modal_folder, setmodal_folder] = useState(false)
    const [modal_file, setmodal_file] = useState(false)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const isBackDisabled = document_info.current_path === "documents";

    const handletextChange = (e) => {
        const value = e
        if (/^[^<>:\"/\\|?*]+$/.test(value)) {
            setFolder_text(value);
        }
    };

    const handleFileChange = (e) => {
        // Convert FileList to a standard JavaScript Array
        const selectedFiles = Array.from(e.target.files);
        setFiles(selectedFiles);
    };

    useEffect(() => {
        api_dcuments_browse('documents')
        return () => {
            setDocument_info({
                selected_all: false,
                control_folder: false,
                control_file: false,
                step_back: 'documents',
                current_path: 'documents',
                doc_list: []
            });
        }
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        if (document_info.selected_all === true) {
            item_selectall()
        } else {
            item_reselall()
        }
    }, [document_info.selected_all]);

    useEffect(() => {
        setItems_Count_Selected(document_info.doc_list.filter((element) => element.selected === true).length)
    }, [document_info.doc_list]);

    async function api_dcuments_browse(current_path) {
        const formData = new FormData()
        formData.append('current_path', current_path)
        formData.append('sitelist', props.permitdata.sitescope_str)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/browse", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                setFolder_text("")
                setDocument_info({
                    selected_all: false,
                    control_folder: false,
                    control_file: false,
                    step_back: 'documents',
                    current_path: 'documents',
                    doc_list: []
                });
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_dcuments_create_dir() {
        if (document_info.current_path === "") {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Directory invalid!",
                enable: true
            });
            return
        }

        var formelement = formfolderRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            setmodal_load({ enable: true, message: "Creating directory...." })
            await sleep(500)

            const formData = new FormData()
            formData.append('current_path', document_info.current_path)
            formData.append('add_item', folder_text)
            formData.append('apply_allsite', apply_all_sites)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/dir/add", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setmodal_folder(false)
                        setFolder_text("")
                        setApply_all_sites(false)
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your directory has been created.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.data !== null && response.data.data !== undefined) {
                        setDocument_info(response.data.data)
                    }
                })
                .catch((err) => {
                    setFolder_text("")
                    setDocument_info({
                        selected_all: false,
                        control_folder: false,
                        control_file: false,
                        step_back: 'documents',
                        current_path: 'documents',
                        doc_list: []
                    });
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_dcuments_remove_single(filename) {
        setmodal_load({ enable: true, message: "Deleting item...." })
        await sleep(500)

        const formData = new FormData()
        formData.append('current_path', document_info.current_path)
        formData.append('filename', filename)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/remove/single", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your file/directory has been deleted.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                setFolder_text("")
                setDocument_info({
                    selected_all: false,
                    control_folder: false,
                    control_file: false,
                    step_back: 'documents',
                    current_path: 'documents',
                    doc_list: []
                });
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_dcuments_remove_multi() {
        const found = document_info.doc_list.find((element) => element.selected === true);
        if (found === undefined) {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Please select at least 1 item!",
                enable: true
            })
            return
        }
        setmodal_load({ enable: true, message: "Deleting item...." })
        await sleep(500)

        const found_selected = document_info.doc_list.filter((element) => element.selected === true);

        const formData = new FormData()
        formData.append('current_path', document_info.current_path)
        formData.append('filelist', JSON.stringify(found_selected))
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/remove/multi", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your files/directorys has been deleted.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                setFolder_text("")
                setDocument_info({
                    selected_all: false,
                    control_folder: false,
                    control_file: false,
                    step_back: 'documents',
                    current_path: 'documents',
                    doc_list: []
                });
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_upload_file() {
        if (files.length === 0) {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Please select at least 1 file!.",
                enable: true
            });
            return
        }

        setmodal_load({ enable: true, message: "Uploading files...." })
        await sleep(500)

        const formData = new FormData();
        formData.append('current_path', document_info.current_path)
        files.forEach((file) => {
            formData.append("files", file);
        });

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/upload", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                rerset_input_file()
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setmodal_file(false)
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your files has been uploaded.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                rerset_input_file()
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_update_single() {
        setmodal_load({ enable: true, message: "Updating document to local...." })
        await sleep(500)

        const sp = document_info.current_path.split("/")
        if (sp.length < 2) {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: "Directory invalid!",
                enable: true
            })
            return
        }
        const formData = new FormData();
        formData.append('sitecode', sp[1])

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/mark/single", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your documents has been updated.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_update_all() {
        setmodal_load({ enable: true, message: "Updating document to local...." })
        await sleep(500)

        const formData = new FormData();
        formData.append('sitecode', "all")
        files.forEach((file) => {
            formData.append("files", file);
        });

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/mark/all", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your documents has been updated.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function api_click_folder(isdir, pathname) {
        if (isdir === true) {
            api_dcuments_browse(pathname)
        }
    }

    function open_pdf(timestamp, file_link) {
        let url = process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/reader?ts=" + timestamp + "&&filename=" + file_link
        window.open(url, "_blank")
    }


    function download_pdf(timestamp, file_link, file_name) {
        let url = process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/download?ts=" + timestamp + "&&filename=" + file_link
        const link = document.createElement("a");
        link.href = url
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function get_file_icon(ext) {
        if (ext === ".pdf") {
            return 'mdi mdi-file-pdf-outline file-color-pdf  me-2'
        } else if (ext === ".xls" || ext === ".xlsx") {
            return 'mdi mdi-file-excel-outline file-color-excel  me-2'
        } else if (ext === ".doc" || ext === ".docx") {
            return 'mdi mdi-file-word-outline file-color-word  me-2'
        } else if (ext === ".ppt" || ext === ".pptx") {
            return 'mdi mdi-file-powerpoint-outline file-color-ppt  me-2'
        } else if (ext === ".csv") {
            return 'mdi mdi-file-delimited-outline file-color-csv  me-2'
        } else if (ext === ".txt") {
            return 'mdi mdi-file-outline file-color-txt  me-2'
        } else if (ext === ".dwg") {
            return 'mdi mdi-file-cad file-color-dwg  me-2'
        } else if (ext === ".jpg" || ext === ".jpeg" || ext === ".png" || ext === ".bmp") {
            return 'mdi mdi-file-image-outline file-color-image  me-2'
        } else if (ext === "folder") {
            return 'mdi mdi-folder file-color-folder me-2'
        } else if (ext === ".exe" || ext === ".msi") {
            return 'mdi mdi-file-cog file-color-unknown me-2'
        }
        return 'mdi mdi-file-outline file-color-unknown  me-2'
    }

    function item_selectall() {
        const nextdata = document_info.doc_list.map(item => {
            return {
                ...item,
                selected: true,
            };
        });
        setDocument_info({
            ...document_info,
            doc_list: nextdata
        })
    }

    function item_reselall() {
        const nextdata = document_info.doc_list.map(item => {
            return {
                ...item,
                selected: false,
            };
        });
        setDocument_info({
            ...document_info,
            doc_list: nextdata
        })
    }

    function rerset_input_file() {
        fileimportRef.current.value = null
        setFiles([])
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-file-alt"></i> Project Documents</h4>
                                    <p className="mb-0">Manage all project documents</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-1" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.step_back) }} disabled={isBackDisabled}><i className="fa fa-arrow-left me-2"></i> Back</button>
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.current_path) }} ><i className="fas fa-sync-alt me-2"></i> Refresh</button>
                            </div>
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-warning btn-sm" type="button" onClick={() => { setmodal_folder(true); setApply_all_sites(false) }} disabled={!document_info.control_folder}><i className="fa fa-folder-plus me-2"></i> Create Directory</button>
                                <button className="btn btn-warning btn-sm" type="button" onClick={() => { setmodal_file(true) }} disabled={!document_info.control_file}><i className="fas fa-file-import me-2"></i> Upload Files</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_dcuments_remove_multi() }} disabled={(!document_info.control_folder && !document_info.control_file) || items_count_selected === 0}><i className="fas fa-eraser me-2"></i> Remove All Selected</button>
                                <button className="btn btn-primary btn-sm" type="button" onClick={() => { api_update_single() }} disabled={!document_info.control_folder && !document_info.control_file}><i className="fas fa-clock me-2"></i> Mark Update Site</button>
                                <button className="btn btn-primary btn-sm" type="button" onClick={() => { api_update_all() }} disabled={document_info.control_folder || document_info.control_file}><i className="fas fa-clock me-2"></i> Mark Update All</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Document Path : {document_info.current_path} ....... (found {document_info.doc_list.length} items)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th><div style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                setDocument_info({
                                                    ...document_info,
                                                    selected_all: !document_info.selected_all
                                                })
                                            }}>...</div></th>
                                        <th>Name</th>
                                        <th>Date Modify</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        document_info.doc_list?.map((data, index) => (
                                            <tr key={data.file_link}>
                                                <td width={'50px'}>
                                                    <div className='d-flex'>

                                                        {
                                                            document_info.control_folder === true || document_info.control_file === true ?
                                                                <div className="form-check">
                                                                    <input id={data.file_link} name={data.file_link} className="form-check-input" type="checkbox" checked={data.selected} onChange={(e) => {
                                                                        const nextdata = document_info.doc_list.map(item => {
                                                                            if (item.file_link === data.file_link) {
                                                                                return {
                                                                                    ...item,
                                                                                    selected: !item.selected,
                                                                                };
                                                                            } else {
                                                                                return item;
                                                                            }
                                                                        });
                                                                        setDocument_info({
                                                                            ...document_info,
                                                                            doc_list: nextdata
                                                                        })
                                                                    }} />
                                                                </div>
                                                                :
                                                                <>{index + 1}</>
                                                        }
                                                    </div>
                                                </td>
                                                <td><div className={data.is_dir ? 'file-items-browser file-cursor' : "file-items-browser"} onClick={() => { api_click_folder(data.is_dir, data.current_path + '/' + data.name) }}><i className={get_file_icon(data.extension)} style={{ fontSize: "16px" }}></i> {data.name} {data.detail}</div></td>
                                                <td width={'150px'}>{data.modify_time}</td>
                                                <td width={'150px'}>
                                                    {data.is_dir === true ?
                                                        <>
                                                            <Link className="btn btn-sm btn-hover btn-bordered me-1" title="Open Directory" onClick={() => { api_dcuments_browse(data.current_path + '/' + data.name) }}><i className='fa fa-search'></i></Link>
                                                            {
                                                                document_info.control_folder === true ?
                                                                    <Link className="btn btn-sm btn-hover btn-bordered" title="Remove Directory" onClick={() => { api_dcuments_remove_single(data.file_link) }}><i className='fas fa-eraser'></i></Link>
                                                                    : null
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <Link className="btn btn-sm btn-hover btn-bordered me-1" title="View File" onClick={() => { open_pdf(data.timestamp, data.file_link) }}><i class="fa fa-search"></i></Link>
                                                            <Link className="btn btn-sm btn-hover btn-bordered me-1" title="Download" onClick={() => { download_pdf(data.timestamp, data.file_link, data.name) }}><i className='fa fa-download'></i></Link>
                                                            {
                                                                document_info.control_file === true ?
                                                                    <Link className="btn btn-sm btn-hover btn-bordered" title="Remove File" onClick={() => { api_dcuments_remove_single(data.file_link) }}><i className='fas fa-eraser'></i></Link>
                                                                    : null
                                                            }
                                                        </>
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>


                    {
                        modal_folder ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-md modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Create Directory</h4>
                                                <i className="fe-x modal-close" onClick={() => { setmodal_folder(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formfolderRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="directory_name">Directory Name</label>
                                                                <input type="text" className="form-control" name="directory_name" value={folder_text} onChange={(e) => {
                                                                    handletextChange(e.target.value)
                                                                }} required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-check">
                                                                <input id="apply_all_site" name="apply_all_site" className="form-check-input" type="checkbox" checked={apply_all_sites} onChange={(e) => {
                                                                    setApply_all_sites(e.target.checked)
                                                                }} />
                                                                <label htmlFor="apply_all_site" className="form-check-label">Apply all sites</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setmodal_folder(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_dcuments_create_dir() }}><i className="fe-save"></i> OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        modal_file ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-md modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Files Upload</h4>
                                                <i className="fe-x modal-close" onClick={() => { setmodal_file(false); rerset_input_file() }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form action="" method="POST" encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="import_file">File Name</label>
                                                                <input type="file" className="form-control" ref={fileimportRef} onChange={handleFileChange} name="files"
                                                                    accept=".jpg, .jpeg, .bmp, .dwg, .txt, .csv, .pdf, .doc, .docx, .xls, xlsx, .ppt, .pptx" multiple />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            {files.length > 0 && (
                                                                <div>
                                                                    <h6>Selected Files:</h6>
                                                                    <ul>
                                                                        {files.map((file, index) => (
                                                                            <li key={index}>{file.name} ({(file.size / 1024).toFixed(1)} KB)</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setmodal_file(false); rerset_input_file() }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_upload_file() }}><i className="fe-save"></i> OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminDocument